import { Component, h, Host } from "@stencil/core";

@Component({
    tag: "ux-sidebar-content",
    styleUrl: "sidebar-content.scss",
    shadow: false
})
export class SidebarContent {
    render() {
        return (
            <Host class="ux-sidebar-content">
                <slot />
            </Host>
        );
    }
}
